var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoldova(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9569 1.58763C20.8534 0.5705 18.4935 0 16.0004 0C13.5073 0 11.1474 0.5705 9.0439 1.58763L7.65259 16L9.0439 30.4124C11.1474 31.4295 13.5073 32 16.0004 32C18.4935 32 20.8534 31.4295 22.9569 30.4124L24.3482 16L22.9569 1.58763Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.5882C3.69163 4.17613 0 9.6567 0 16C0 22.3433 3.69163 27.8239 9.0435 30.4118V1.5882Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9568 1.5882V30.4118C28.3087 27.8239 32.0003 22.3433 32.0003 16C32.0003 9.6567 28.3087 4.17613 22.9568 1.5882Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 12.5887H17.7391C17.7391 11.6282 16.9605 10.8495 16 10.8495C15.0395 10.8495 14.2609 11.6282 14.2609 12.5887H10.4348C10.4348 13.5344 11.2586 14.3009 12.2042 14.3009H12.1472C12.1472 15.2467 12.9138 16.0134 13.8596 16.0134C13.8596 16.8507 14.4609 17.5464 15.2552 17.6952L13.9058 20.7415C14.5524 21.0043 15.259 21.1504 16 21.1504C16.7409 21.1504 17.4476 21.0043 18.0941 20.7415L16.7448 17.6952C17.5391 17.5464 18.1404 16.8507 18.1404 16.0134C19.0862 16.0134 19.8528 15.2467 19.8528 14.3009H19.7958C20.7414 14.3009 21.5652 13.5343 21.5652 12.5887V12.5887Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 14.9565L13.739 16V18.087L15.9999 19.4783L18.2607 18.087V16L15.9999 14.9565Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.739 13.9131H18.2607V16.0001H13.739V13.9131Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoldova);
export default __webpack_public_path__ + "static/media/moldova.1dbc89e1.svg";
export { ForwardRef as ReactComponent };